import React from 'react';

import CountryInfo from '../CountryInfo';

const PACKAGE_SECTION = {
    title: 'Stimulus Package',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">Details</p>
            <ul>
                <li>3.2 trillion won will make up for the revenue deficit.</li>
                <li>8.5 trillion won for extra fiscal injection.</li>
                <li>
                    Additional 10.3 trillion won in treasury bonds will be
                    issued this year to fund the extra budget.
                </li>
                <li>
                    Small and medium business subsidies to help companies pay
                    workers, child-care subsidies, and job retraining for people
                    who have lost jobs.
                </li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'South Korea unveils $9.8 billion stimulus to fight coronavirus',
            url: 'https://www.reuters.com/article/us-southkorea-economy-budget/south-korea-unveils-9-8-billion-stimulus-to-fight-coronavirus-idUSKBN20R046',
        },
    ],
};

const COUNTRY_INFO = {
    countryName: 'South Korea',
    lastUpdated: 'March 17, 2020',
    introSection: (
        <p>
            South Korea has announced a stimulus package worth $9.8 billion
            (11.7 trillion won).
        </p>
    ),
    sections: [PACKAGE_SECTION],
};

const SouthKoreaInfo = () => <CountryInfo info={COUNTRY_INFO} />;

export default SouthKoreaInfo;
